import {
    ADD_PROPERTY, UPDATE_PROPERTY, DELETE_PROPERTY,
    PROPERTIES_UNITS_FETCH_INITIAL_DATA, BULK_UPLOAD, 
    ADD_UNIT, DELETE_UNIT, 
    ADD_TENANT, DELETE_TENANT, LOAD_PROPERTIES_UNITS_TENANTS, LOG_OUT_USER
} from '../../actions/actionTypes';


const addPropertyReducer = (properties, payload) => {
    let newProperties = { ...properties};
    newProperties[payload.propertyId] = {
        ...payload
    }
    return newProperties;
}

const updatePropertyReducer = (properties, payload) => {
    let newProperties = {...properties};
    newProperties[payload.propertyId] = {
        ...payload,
        numUnits: parseInt(payload.numUnits),
        vacancies: properties[payload.propertyId].vacancies,
        units: properties[payload.propertyId].units
    }
    return newProperties;
}

const deletePropertyReducer = (properties, payload) => {
    let newProperties = {...properties};
    delete newProperties[payload.propertyId];
    return newProperties;
}

const deleteUnitinPropertiesReducer = (properties, payload) => {
    let newProperties = {...properties};
    delete newProperties[payload.propertyId]["units"][payload.unitId];
    return newProperties;
}

const addUnitinPropertiesReducer = (properties, payload) => {
    let newProperties = {...properties};
    if (!payload.occupied){
        let vacancies = newProperties[payload.propertyId].vacancies;
        newProperties[payload.propertyId]["vacancies"] = vacancies + 1;
    }
    newProperties[payload.propertyId]["units"][payload.unitId] = {}
    return newProperties
}

const addTenantinPropertiesReducer = (properties, payload) => {
    let newProperties = {...properties};
    newProperties[payload.propertyId]["units"][payload.unitId][payload.tenantId] = payload.tenantId
    return newProperties;
}

const deleteTenantinPropertiesReducer = (properties, payload) => {
    let newProperties = {...properties};
    delete newProperties[payload.propertyId]["units"][payload.unitId][payload.tenantId];
    return newProperties;
}


const propertiesReducer = (state={}, action) => {
    let  properties = state;
    if (action.errors == null){
        switch(action.type){ 
            case PROPERTIES_UNITS_FETCH_INITIAL_DATA:
                return action.payload.properties;
            case ADD_PROPERTY:
                return addPropertyReducer(properties, action.payload);
            case ADD_UNIT:
                return addUnitinPropertiesReducer(properties, action.payload);
            case ADD_TENANT:
                return addTenantinPropertiesReducer(properties, action.payload);
            case UPDATE_PROPERTY:
                return updatePropertyReducer(properties, action.payload);
            case DELETE_PROPERTY:
                return deletePropertyReducer(properties, action.payload);
            case DELETE_UNIT:
                return deleteUnitinPropertiesReducer(properties, action.payload);
            case DELETE_TENANT:
                return deleteTenantinPropertiesReducer(properties, action.payload);
            case LOAD_PROPERTIES_UNITS_TENANTS:
                return action.payload.properties;
            case BULK_UPLOAD:
                return action.payload.properties;
            case LOG_OUT_USER:
                return {};
            default:
                return properties;
        }
    }else{
        return properties;
    }
};
export default propertiesReducer;
